// src/components/BlankPage.mjs
import React from 'react';

const BlankPage = () => {
    return (
        <div style={{ 
            minHeight: '100vh', 
            backgroundColor: 'white',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            {/* Página em branco - sem conteúdo */}
        </div>
    );
};

export default BlankPage;
